import { ACTIONS } from '../types';
import STATUS from '../../../globalStatuses';

export const militaryCityReductions = {
  [ACTIONS.REQUEST_MILITARY_CITIES]: state => ({
    ...state,
    militaryCitiesStatus: {
      ...state.militaryCitiesStatus,
      getStatus: STATUS.FETCHING,
      errorData: null,
    },
  }),
  [ACTIONS.RECEIVE_MILITARY_CITIES]: (state, action) => ({
    ...state,
    militaryCities: {
      militaryCitiesUS: action.payload.militaryCitiesUS,
    },
    militaryCitiesStatus: {
      ...state.militaryCitiesStatus,
      getStatus: STATUS.FETCHED,
    },
  }),
  [ACTIONS.RECEIVE_MILITARY_CITIES_ERROR]: (state, action) => ({
    ...state,
    error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    militaryCitiesStatus: {
      ...state.militaryCitiesStatus,
      getStatus: STATUS.ERROR,
      errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    },
  }),
};

export default militaryCityReductions;
